import { Pipe, PipeTransform } from '@angular/core';
import { COMMON_CONSTANTS } from 'src/app/common/core/common.constants';

@Pipe({
  name: 'formatMsisdn',
})
export class FormatMsisdnPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value === '' || value === undefined) {
      return '--';
    } else if (value) {
      return COMMON_CONSTANTS.SYMBOLS.BRACKET_OPEN + value.substr(COMMON_CONSTANTS.DIGITS.ZERO, COMMON_CONSTANTS.DIGITS.THREE) + 
          COMMON_CONSTANTS.SYMBOLS.BRACKET_CLOSE + value.substr(COMMON_CONSTANTS.DIGITS.THREE, COMMON_CONSTANTS.DIGITS.THREE)
            + COMMON_CONSTANTS.SYMBOLS.DASH + value.substr(COMMON_CONSTANTS.DIGITS.SIX);        
    }
  }

}

